import groq from 'groq'

export default groq`
  {
    _type == "contactForm" => @-> {
      ...,
      "id": _id
    }
  }
`
